import BaseFeature from '../../foundation/base/base';

export default class FadeinOnIntersect extends BaseFeature {
	constructor(element) {
		super(element);

		this.elm = element;
		this.activeClass = this.elm.dataset.activeclass;
		this.initDomCache();
		this.init();
	}

	init() {
		// If useragent doens't support scroll, then it is properly a Google Bot
		// Therefor all images should be rendered for SEO purposes
		const supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		// If the useragent doesn't support IntersectionObserver, we need to render all images
		const supportIntersectionObserver = 'IntersectionObserver' in window;

		if (supportScroll && supportIntersectionObserver) {
			this.observe();
		} else {
			this.reveal();
		}
	}

	observe() {
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: 0.5
		};
		this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
		this.observer.observe(this.elm);
	}

	handleIntersect(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				this.reveal();
				observer.disconnect();
			}
		});
	}

	reveal() {
		this.elm.classList.add(this.activeClass);
	}
}
